const templateTypes = {
  GLOBAL_TEMPLATE: 1,
  PERSONAL_TEMPLATE: 2,
  EMPLOYEE_TEMPLATE: 3
}

export default templateTypes



// WEBPACK FOOTER //
// ./src/constants/templateTypes.js